import * as React from "react";
import { connect } from "common/connect";
import StoreKeys from "common/storeKeys";
import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";
import SvgViewer from "bracket-system/svg-viewer";
import {
    BountyModel,
    bountyModelContext,
    fillBountyFreeformParts,
} from "common/helpers/bountyHelper";
import BountyBracket from "./BountyBracket";
import BountyBracketEditor from "./BountyBracketEditor";
import useBracketViewport from "common/hooks/bracketViewportHook";

const useStyles = makeStyles((theme) => {
    return {
        bracketWrapper: {
            border: `2px solid ${Colors.panel}`,
            borderRadius: theme.shape.borderRadius,
            overflow: "hidden",
            userSelect: "none",
            // takes whatever height the page has left, so the buttons below stay visible
            flex: "1 1 0px",
            minHeight: 200,
        },
    };
});

const propKeys = {
    eventData: StoreKeys.EVENT.EVENTDATA,
    format: StoreKeys.EVENT.FORMAT,
    userBracketPicks: StoreKeys.EVENT.USER.BRACKET_PICKS,
    officialBracketPicks: StoreKeys.EVENT.OFFICIAL.BRACKET_PICKS,
    isEditing: StoreKeys.EVENT.IS_EDITING,
    stageIndex: StoreKeys.EVENT.STAGE_INDEX,
    showOfficial: StoreKeys.EVENT.SHOW_OFFICIAL,
};

function BountyBracketRendererC({
    eventData,
    format,
    userBracketPicks,
    officialBracketPicks,
    isEditing,
    stageIndex,
    showOfficial,
}) {
    const ref = React.useRef();
    const styles = useStyles();
    const {
        width: viewerWidth,
        height: viewerHeight,
        ready,
    } = useBracketViewport(ref);

    const currentStage = format.stages[stageIndex];
    const currentEventStage = eventData.eventStages[stageIndex];

    const model = new BountyModel(
        bountyModelContext(
            eventData,
            currentStage,
            currentEventStage,
            officialBracketPicks,
            userBracketPicks
        )
    );

    const parts = fillBountyFreeformParts(model, eventData.teams, {
        official: showOfficial,
        withCues: !showOfficial,
    });

    // memoized so re-renders don't remount and reset the viewer
    const svgWrapper = React.useCallback(
        ({ children, ...props }) => (
            <SvgViewer width={viewerWidth} height={viewerHeight} {...props}>
                {children}
            </SvgViewer>
        ),
        [viewerWidth, viewerHeight]
    );

    return (
        <>
            {isEditing && <BountyBracketEditor />}
            {!isEditing && (
                <div className={styles.bracketWrapper} ref={ref}>
                    {ready && (
                        <BountyBracket
                            parts={parts}
                            svgWrapper={svgWrapper}
                            hideSeriesScore={!model.useSeriesScore}
                        />
                    )}
                </div>
            )}
        </>
    );
}

export default function BountyBracketRenderer(props) {
    return connect(<BountyBracketRendererC />, propKeys, props);
}
